import { render, staticRenderFns } from "./click-image-component.vue?vue&type=template&id=331dd99a&scoped=true&"
import script from "./click-image-component.vue?vue&type=script&lang=ts&"
export * from "./click-image-component.vue?vue&type=script&lang=ts&"
import style0 from "./click-image-component.vue?vue&type=style&index=0&id=331dd99a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dd99a",
  null
  
)

export default component.exports